export default "__VITE_ASSET__389c1d70__"